<template>
  <section class="section cloud-balancer">
    <div class="section__container cloud-balancer__container">
      <h2 class="section__title cloud-balancer__title">Внутри сервиса Ferma используется софт «Облачный балансировщик»</h2>
      <div class="cloud-balancer__text">
        <p class="cloud-balancer__text-par">«Облачный балансировщик» равномерно распределяет нагрузку между кассами, позволяя
          снизить их количество до 50%.</p>
        <div class="cloud-balancer__example">
          <h4 class="cloud-balancer__example-title">Пример:</h4>
          <p class="cloud-balancer__example-txt">необходимое число облачных касс для интернет-магазина с максимальным числом
            транзакций — 7 в секунду</p>
          <ul class="cloud-balancer__numbers">
            <li class="cloud-balancer__numbers-item">
              <p class="cloud-balancer__numbers-desc">При использовании сторонних сервисов</p>
              <p class="cloud-balancer__numbers-number">18</p>
            </li>
            <li class="cloud-balancer__numbers-item">
              <p class="cloud-balancer__numbers-desc">При пользовании сервисом FERMA</p>
              <p class="cloud-balancer__numbers-number">10</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="cloud-balancer__calc"
           v-bind:class="{'cloud-balancer__calc_opened': opened}">
        <div class="cloud-balancer__calc-header">
          <div class="cloud-balancer__calc-text">Рассчитайте сколько касс вам необходимо</div>
          <a v-on:click="toggleOpen"
             v-bind:class="{'button-round_opened': opened}"
             class="button-round button-round_gray cloud-balancer__calc-action">
            <img src="../../assets/images/chevron.svg" alt="">
          </a>
        </div>
        <div v-if="opened" class="cloud-balancer__calc-content">
          <p class="cloud-balancer__calc-title">Подберите оптимальное количество касс исходя из среднего количества продаж в сутки и
            максимального количества транзакций за день</p>
          <div class="cloud-balancer__inputs-row">
            <div>
              <div class="cloud-balancer__input-label">Среднее количество продаж в сутки</div>
              <v-text-field
                v-model="numberOfSales"
                type="number"
                min="1"
                @keypress="onlyNumber"
                v-on:input="kktCalc"
                :rules="[rules.required]"
              ></v-text-field>
            </div>
            <div>
              <div class="cloud-balancer__input-label">Максимально возможное количество транзакций за секунду</div>
              <v-text-field
                v-model="numberOfTransactions"
                type="number"
                min="1"
                @keypress="onlyNumber"
                v-on:input="kktCalc"
                :rules="[rules.required]"
              ></v-text-field>
            </div>
          </div>
          <div class="cloud-balancer__kkt-result">
            <div class="cloud-balancer__kkt-result-text">
              Рекомендуемое
              <br/>количество касс:
            </div>
            <div class="cloud-balancer__kkt-result-number">{{recommendKktCount}}</div>
          </div>
          <div class="cloud-balancer__calc-goto">
            <a class="button" v-scrollTo="'calc'">
              Подключить Ferma
              <img src="../../assets/images/chevron.svg" alt="">
            </a>
          </div>
        </div>
      </div>
      <div class="cloud-balancer__action">
        <a class="button" v-scrollTo="'calc'">
          Подключить Ferma
          <img src="../../assets/images/chevron.svg" alt="">
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CloudBalancer',
  data() {
    return {
      opened: false,
      rules: {
        required: value => !!value || 'Обязательное поле',
      },
      numberOfSales: 1,
      numberOfTransactions: 1,
      recommendKktCount: 1,
    }
  },
  methods: {
    toggleOpen: function () {
      this.opened = !this.opened;
    },
    onlyNumber: function (e) {
      var txt = String.fromCharCode(e.which);
      switch (txt) {
        case '-':
        case '+':
          e.preventDefault();
          break;
      }
    },
    kktCalc: function () {
      this.recommendKktCount = Math.max(Math.ceil(this.numberOfSales / 43200 / 0.34), this.numberOfTransactions);
    },
  },
}
</script>

<style src="./component.scss" scoped lang="scss"/>

